<template>

    <Head :title="__('Password reset')" />

    <div class="flex align-items-center justify-content-center min-h-screen p-3">
        <v-form name="formForget"
                class="w-full"
                style="max-width:26rem"
                @keyup.enter="send">
            <Card>
                <template #header>
                    <div class="flex justify-content-center pt-4">
                        <Image :src="systemLogo"
                               width="140" />
                    </div>
                </template>

                <template #content>
                    <Message v-if="success"
                             severity="success"
                             :closable="false"
                             class="mb-3">
                        {{ __('Link was send') }}
                    </Message>

                    <div class="flex flex-column gap-2 mb-4">
                        <label for="email">{{ __('E-Mail Address') }}</label>
                        <InputText type="text"
                                   id="email"
                                   size="small"
                                   class="w-full"
                                   @input="inputNewData"
                                   :invalid="!!form.errors.email"
                                   v-model="form.email" />
                        <small v-if="form.errors.email"
                               class="p-error">{{ __(form.errors.email) }}</small>
                    </div>

                    <Button @click="send"
                            :label="__('Send Password Reset Link')"
                            icon="pi pi-sign-in"
                            class="w-full" />

                    <div class="text-center mt-3">
                        <Link :href="route('app-login')"
                              :aria-hidden="false"
                              v-if="route().has('app-login')">
                            <i class="pi pi-star mr-2"></i>{{ __('Login') }}
                        </Link>
                    </div>
                </template>
            </Card>
        </v-form>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { Head } from '@inertiajs/vue3'
import { Link } from '@inertiajs/vue3'

import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Card from 'primevue/card';
import Message from 'primevue/message';

import Layout from '@layouts/LayoutNoMenuNoFooter.vue'
import Image from '@helper/Image.vue'
import { __ } from '@helper/utils.js'
import { systemLogo, startSplash } from '@helper/constants.js'

defineOptions({ layout: Layout })

// -----------------------------------------------------

const success = ref(false)
const form = useForm({ email: '' })

// -----------------------------------------------------

const inputNewData = () => {
    form.errors.email = null
    success.value = false
}

// -----------------------------------------------------

const send = () => {
    form.post(route('password.email'), {
        onSuccess: () => {
            success.value = true
            form.email = ''
        },
        onError: (errors) => { console.error(errors) }
    })
}

// -----------------------------------------------------
</script>

<style lang="scss" scoped></style>
